import { App } from './views/App';
import React from "react";
import { BrowserRouter } from "react-router-dom";
import { render } from "react-dom";

render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);